import { DownloadBtnPkmt } from 'src/components/download-btn-pkmt';

export default DownloadBtnPkmt;
